import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation, useQueryClient } from "react-query";
import { ApiResultModel } from "../../../models/common.model";
import {
  DeleteCartItemResponse,
  FinalizerOrderItemsRequest,
  StoreResponse,
} from "../../models/store.model";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import {
  FinalizerOrderItems,
  GetCartSummary,
} from "../../service/store.service";
import * as Yup from "yup";
import TrackingCodeModal from "./trackingCodeModal";
import { useDispatch } from "react-redux";
import { setCartCount } from "../../redux/cartSummary/cartCountAction";
import { error } from "console";
import { v4 as uuid } from "uuid";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
interface props {
  openCancelModal: boolean;
  setOpenCancelModal: any;
  requestModel: any;
  setUpdateCart?: any;
  setValidationIssues?: any;
}
export default function FinalModal({
  openCancelModal,
  setOpenCancelModal,
  requestModel,
  setUpdateCart,
  setValidationIssues,
}: props) {
  const handleClose = () => setOpenCancelModal(false);
  const handleOpen = () => setOpenCancelModal(true);
  const [openTrackingModal, setOpenTrackingModal] = React.useState<boolean>(
    false
  );

  const yupMaxPostalCode = 10;
  const validationSchema = Yup.object().shape({
    recipientPostalCode: Yup.string()
      .required("فیلد اجباری است.")
      .matches(/^[0-9]+$/, "کدپستی فقط عدد می باشد")
      .max(yupMaxPostalCode, "کد پستی ده رقم می باشد")
      .min(yupMaxPostalCode, "کد پستی ده رقم می باشد"),
    recipientName: Yup.string()
      .required("فیلد اجباری است."),
    recipientPhone: Yup.string()
      .matches(/^[0-9]+$/, "شماره تلفن فقط عدد می باشد")
      .required("فیلد اجباری است."),
    deliveryAddress: Yup.string()
      .required("فیلد اجباری است."),
  });

  const { mutate: finalizerOrderItems } = useMutation(FinalizerOrderItems, {
    onSuccess: (result: ApiResultModel<StoreResponse[]>) => {
      if (result.isSuccess === true) {
        setUpdateCart(uuid());
        handleClose();
        setOpenTrackingModal(true);
        // setCartData(result.data);
        cartSummaryMutate.mutate();
      } else {
        setOpenTrackingModal(false);
        result?.data?.map((item: any) =>
          item.isValid === false
            ? setValidationIssues(item.validationIssues)
            : ""
        );
      }
    },
  });
  const dispatch = useDispatch();
  const cartSummaryMutate = useMutation(GetCartSummary, {
    onSuccess: (data) => {
      dispatch(setCartCount({ count: data.data }));
    },
  });

  const handelVerify = (value: any) => {
    const finalizerOrderObj = {} as FinalizerOrderItemsRequest;
    finalizerOrderObj.deliveryAddress = value.deliveryAddress;
    finalizerOrderObj.recipientName = value.recipientName;
    finalizerOrderObj.recipientPhone = value.recipientPhone;
    finalizerOrderObj.recipientPostalCode = value.recipientPostalCode;
    finalizerOrderObj.items = requestModel;
    finalizerOrderItems(finalizerOrderObj!);
  };

  const handelCancel = () => {
    handleClose();
    setOpenTrackingModal(false);
    // setCartData(result.data);
  };
  return (
    <div>
      <Modal
        open={openCancelModal}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          validateOnMount={true}
          initialValues={{} as FinalizerOrderItemsRequest}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handelVerify(values);
          }}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                sx={style}
                style={{
                  borderRadius: "6px",
                  padding: "40px 70px 70px 60px",
                  width: "61vh",
                  marginTop: "60px",
                }}
                className="ModalCmp textCenter "
              >
                <div>
                  <Typography className="textCenter colorDefaultFont textFont16 mTop30 mbottom40">
                    در صورتیکه از{" "}
                    <span className="colorGreen">"ثبت نهایی"</span> این درخواست
                    اطمینان دارید،
                    <span className="colorGreen">"اطلاعات تحویل گیرنده"</span>
                    <span>را وارد نمایید.</span>
                  </Typography>
                </div>
                <Grid container>
                  <Grid item xs={12} style={{ marginBottom: "30px" }}>
                    <MaterialTextFieldComponent
                      className="shadowTextField"
                      placeHolder={"*نام تحویل گیرنده"}
                      label={"*نام تحویل گیرنده"}
                      required={true}
                      value={values.recipientName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="recipientName"
                      id="recipientName"
                      helperText={
                        touched?.recipientName
                          ? errors!.recipientName
                          : ""
                      }
                      error={
                        touched?.recipientName &&
                        Boolean(errors?.recipientName)
                      }
                    />
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    columns={16}
                    style={{ marginBottom: "30px" }}
                  >
                    <Grid item xs={8}>
                      <MaterialTextFieldComponent
                        className="shadowTextField"
                        placeHolder={"*شماره تماس"}
                        label={"*شماره تماس"}
                        required={true}
                        value={values.recipientPhone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="recipientPhone"
                        id="recipientPhone"
                        helperText={
                          touched?.recipientPhone
                            ? errors!.recipientPhone
                            : ""
                        }
                        error={
                          touched?.recipientPhone &&
                          Boolean(errors?.recipientPhone)
                        }
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <MaterialTextFieldComponent
                        className="shadowTextField"
                        placeHolder={"*کدپستی"}
                        label={"*کدپستی"}
                        required={true}
                        value={values.recipientPostalCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="recipientPostalCode"
                        id="recipientPostalCode"
                        inputProps={{ maxLength: 10, minLength: 10 }}
                        helperText={
                          touched?.recipientPostalCode
                            ? errors!.recipientPostalCode
                            : ""
                        }
                        error={
                          touched?.recipientPostalCode &&
                          Boolean(errors?.recipientPostalCode)
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: "30px" }}>
                    <MaterialTextFieldComponent
                      className={"shadowTextField"}
                      label={"*آدرس"}
                      required={true}
                      rows={2}
                      value={values.deliveryAddress}
                      onChange={handleChange}
                      name="deliveryAddress"
                      id="deliveryAddress"
                      multiline
                      sx={{
                        "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                          fontSize: 13,
                          lineHeight: "2vh !important",
                          height: "6vh !important",
                        },

                        "& .MuiInputBase-root": {
                          height: "10vh !important",
                        },
                      }}
                      placeHolder={"*آدرس"}
                      helperText={
                        touched?.deliveryAddress
                          ? errors!.deliveryAddress
                          : ""
                      }
                      error={
                        touched?.deliveryAddress &&
                        Boolean(errors?.deliveryAddress)
                      }
                    />
                  </Grid>
                  <Grid container spacing={2} columns={16} className="mTop20">
                    <Grid item xs={8}>
                      <Button
                        type="submit"
                        disabled={Object.keys(errors).length > 0}
                        className={`${Object.keys(errors).length > 0
                          ? "btnForm disabledBtn  "
                          : "btnForm SuccessDefault "
                          }`}
                        // onClick={handelVerify}
                        fullWidth
                      >
                        ثبت و تایید نهایی
                      </Button>
                    </Grid>
                    <Grid item xs={8}>
                      <Button
                        onClick={handelCancel}
                        fullWidth
                        className="btnForm ComingBack"
                      >
                        انصراف
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </form>
          )}
        </Formik>
      </Modal>
      <TrackingCodeModal
        setOpenTrackingModal={setOpenTrackingModal}
        openTrackingModal={openTrackingModal}
      />
    </div>
  );
}
